import { useEffect, useState } from "react";

import { useSelector } from "@jti/store/reduxHooks";
import { selectOrderDeliveryLimits } from "@jti/store/selectors/selectOrderDeliveryLimits";
import { selectShippingAddressSelected } from "@jti/store/selectors/selectShippingAddressSelected";
import { useCountry } from "@jti/ui";

import { checkIfCityLimitModeEnabled, searchForTheCity } from "@checkout/utils";

type UseDeliveryLimitOptions = {
  enabled?: boolean;
};

export const useDeliveryLimit = ({ enabled = true }: UseDeliveryLimitOptions = {}) => {
  const [isDeliveryLimitError, setIsDeliveryLimitError] = useState(false);
  const orderDeliveryLimits = useSelector(selectOrderDeliveryLimits);
  const country = useCountry();

  const shippingAddressSelected = useSelector((state) => selectShippingAddressSelected(state, country));
  const isDeliveryLimitEnabled = !!orderDeliveryLimits?.mode && checkIfCityLimitModeEnabled(orderDeliveryLimits.mode);

  useEffect(() => {
    if (!enabled) {
      setIsDeliveryLimitError(false);
      return;
    }

    if (shippingAddressSelected && isDeliveryLimitEnabled) {
      const { city } = shippingAddressSelected;
      const { limits } = orderDeliveryLimits;
      if (city) {
        const matchingCitiesCount = searchForTheCity(city, limits);
        setIsDeliveryLimitError(matchingCitiesCount === 0);
      }
    } else {
      setIsDeliveryLimitError(false);
    }
  }, [enabled, shippingAddressSelected, isDeliveryLimitEnabled, orderDeliveryLimits]);

  return { isDeliveryLimitError };
};
